module.exports = __webpack_public_path__ + "static/media/icon-caret-down.b69846c4.svg";